export default __webpack_public_path__ + "4dc8464e1433ab9b3465c34ccd87fd33.svg";